/** @module Pick a storage location: boxes, their compartments and decks, by their full path. */
import { useId } from "react";
import { useTranslation } from "react-i18next";

import { type Location, treeOrder, useLocations } from "@/lib/locations";

export function LocationSelect({
  value,
  onChange,
  label,
  noneLabel,
  only,
}: {
  value: string | null;
  onChange: (value: string | null) => void;
  label?: string;
  /** What "no place" means here: "Kein Lagerort", "Oberste Ebene" … */
  noneLabel?: string;
  /** Restrict the choice, e.g. to the places a location may move under. */
  only?: Location[];
}) {
  const { t } = useTranslation();
  const id = useId();
  const locations = useLocations();
  const choices = treeOrder(only ?? locations.data?.items ?? []);
  return (
    <div className="field">
      <label htmlFor={id} className="field-label">
        {label ?? t("locations.label")}
      </label>
      <select
        id={id}
        className="input"
        value={value ?? ""}
        onChange={(event) => {
          onChange(event.target.value || null);
        }}
      >
        <option value="">{noneLabel ?? t("locations.none")}</option>
        {choices.map(({ location }) => (
          <option key={location.id} value={location.id}>
            {location.kind === "deck"
              ? `${location.path} (${t("locations.kind.deck")})`
              : location.path}
          </option>
        ))}
      </select>
    </div>
  );
}
